import { createContext } from 'react';

import type { CommercialCardContext__DEPRICATED } from './types';

/**
 * Заменяет legacy context API (childContextTypes/contextTypes), удалённый в React 19.
 * Значение по умолчанию не используется: провайдер всегда есть выше по дереву.
 */
export const CommercialCardContext = createContext<CommercialCardContext__DEPRICATED>(
  {} as CommercialCardContext__DEPRICATED,
);
